import React, { useContext } from 'react';
import proptypes from 'prop-types';
const {
  arrayOf, shape, string, bool, oneOfType
} = proptypes;
import { QueryContext, QueryProvider, extend } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductPodWrapper } from './product-pod/ProductPodWrapper';

const ElligibleItems = ({
  products,
  anchorItem,
  openInQuickViewDescription,
  openDetailsInNewTab,
  hideQuickViewMask,
  hideKPF,
  showDimensions,
  dimensionsDisplay,
  hideSelectionButton,
  openQuickViewOnPodClick,
  zeroBasedPositions
}) => {
  const { storeId } = useStore();
  const { defaultVariables } = useContext(QueryContext) || {};

  const newDefaultVariables = {
    storeId,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  return (
    <div>
      {products?.map((product, index) => (
        <div key={product.itemId}>
          <QueryProvider
            cacheKey="swap-item-product-pod-mini"
            defaultVariables={newDefaultVariables}
            dataSource={product.dataSource}
          >
            <ProductPodWrapper
              product={product}
              anchorItem={anchorItem}
              swapItemPosition={zeroBasedPositions ? index : index + 1}
              openInQuickViewDescription={openInQuickViewDescription}
              openDetailsInNewTab={openDetailsInNewTab}
              hideQuickViewMask={hideQuickViewMask}
              hideKPF={hideKPF}
              showDimensions={showDimensions}
              dimensionsDisplay={dimensionsDisplay}
              hideSelectionButton={hideSelectionButton}
              openQuickViewOnPodClick={openQuickViewOnPodClick}
            />
          </QueryProvider>
        </div>
      ))}
    </div>
  );
};

ElligibleItems.propTypes = {
  products: arrayOf(shape({})).isRequired,
  anchorItem: string,
  openInQuickViewDescription: bool,
  openDetailsInNewTab: bool,
  hideQuickViewMask: bool,
  hideKPF: bool,
  showDimensions: bool,
  dimensionsDisplay: shape({
    // [[spec names in order of preference, axis label]], e.g. FIT_DIMENSION_SPECS
    specs: arrayOf(arrayOf(oneOfType([string, arrayOf(string)]))),
    variant: string
  }),
  hideSelectionButton: bool,
  openQuickViewOnPodClick: bool,
  zeroBasedPositions: bool
};

ElligibleItems.defaultProps = {
  anchorItem: null,
  openInQuickViewDescription: false,
  openDetailsInNewTab: false,
  hideQuickViewMask: false,
  hideKPF: false,
  showDimensions: false,
  dimensionsDisplay: undefined,
  hideSelectionButton: false,
  openQuickViewOnPodClick: false,
  zeroBasedPositions: false
};

ElligibleItems.displayName = 'ElligibleItems';

ElligibleItems.dataModel = ProductPodWrapper.dataModel;

export { ElligibleItems };
